import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrent() {


const cardData = {
keyword: "Tempo Traveller On Rent",
headingDescription: "Ruturaj Enterprises provides convenient Tempo Traveller On Rent services in Pune for families, friends, corporate teams, wedding groups, school parties, airport transfers, picnics, and sightseeing tours. Travelers can select suitable AC, non-AC, or luxury Tempo Traveller options according to group size, travel distance, comfort requirements, and trip duration. Whether the requirement is for a one-day local journey, an outstation holiday, a wedding function, or a multi-day group tour, transportation can be arranged with practical pickup and drop-off planning.",
topPlaces: [
{
title: "Lonavala",
description: "Lonavala is a popular hill destination near Pune, known for scenic viewpoints, valleys, waterfalls, and pleasant weekend-trip experiences. A Tempo Traveller is a convenient option for families and groups visiting several attractions together without needing multiple cars."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar offers scenic viewpoints, lush landscapes, strawberry farms, and a variety of attractions suitable for family holidays and group tours. Comfortable group transportation makes it easier to travel between sightseeing locations while keeping everyone together."
},
{
title: "Shirdi",
description: "Shirdi is an important pilgrimage destination that attracts families and devotional groups from Pune throughout the year. A dedicated Tempo Traveller provides shared transportation for temple visits and can also accommodate luggage and additional sightseeing stops."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal getaway offering beaches, historic attractions, and relaxed weekend experiences. Families and friends can use a Tempo Traveller to travel together from Pune and explore multiple nearby locations during a short or extended trip."
},
{
title: "Nashik",
description: "Nashik combines pilgrimage attractions, vineyards, historic locations, and scenic surroundings, making it suitable for different types of group tours. A dedicated Tempo Traveller can provide convenient transportation for families, corporate teams, and friends exploring the city and nearby destinations."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a popular pilgrimage and nature destination surrounded by scenic landscapes. A Tempo Traveller is useful for groups traveling together from Pune, particularly when the itinerary involves temple visits along with nearby sightseeing."
},
{
title: "Matheran",
description: "Matheran is a scenic hill destination known for viewpoints, greenery, and its peaceful atmosphere. Groups can travel by Tempo Traveller up to the appropriate access point and coordinate their journey conveniently as part of a weekend or family tour."
},
{
title: "Panchgani",
description: "Panchgani is known for its hill scenery, viewpoints, valleys, and family-friendly holiday attractions. A dedicated Tempo Traveller allows groups to travel comfortably from Pune while maintaining flexibility for sightseeing and meal stops along the route."
},
{
title: "Bhandardara",
description: "Bhandardara offers lakes, mountain landscapes, waterfalls, and peaceful surroundings, making it a popular destination for group trips and nature holidays. Tempo Traveller transportation is well suited to groups carrying luggage and planning multiple stops during the journey."
},
{
title: "Lavasa",
description: "Lavasa provides a scenic getaway with lakeside surroundings, hills, and leisure activities suitable for families and friends. A Tempo Traveller gives groups a convenient shared vehicle for the journey from Pune and local travel during the planned outing."
}
],
services: [
{
name: "Tempo Traveller Rental Pune",
description: "Tempo Traveller Rental Pune provides a practical group transportation solution for families, friends, corporate teams, and organized tour parties. Ruturaj Enterprises can arrange a suitable vehicle according to passenger count, travel distance, luggage requirements, and the expected duration of the journey."
},
{
name: "Tempo Traveller Hire Pune",
description: "Tempo Traveller Hire Pune is suitable for local travel, outstation trips, sightseeing, weddings, airport transfers, and special events. Groups can select a vehicle according to their seating requirement and preferred level of comfort for the planned journey."
},
{
name: "Tempo Traveller Booking Pune",
description: "Tempo Traveller Booking Pune allows travelers to arrange their group transportation in advance according to their travel dates and itinerary. Booking requirements can include passenger capacity, pickup location, destination, trip duration, luggage needs, and AC or non-AC preference."
},
{
name: "AC Tempo Traveller on Rent Pune",
description: "AC Tempo Traveller on Rent Pune offers a comfortable travel environment for families and groups traveling around Pune or covering longer outstation routes. Air-conditioned interiors are especially useful during extended road journeys, sightseeing tours, and multi-day trips."
},
{
name: "Non AC Tempo Traveller Pune",
description: "Non AC Tempo Traveller Pune provides a practical transportation option for groups looking for a straightforward and economical vehicle for their journey. It can be considered for local travel, picnics, short trips, family outings, and selected outstation routes."
},
{
name: "Luxury Tempo Traveller Pune",
description: "Luxury Tempo Traveller Pune is suitable for groups seeking enhanced comfort during family vacations, corporate travel, weddings, and special occasions. A premium group vehicle provides a convenient shared travel environment for passengers who prefer a more comfortable journey."
},
{
name: "Tempo Traveller for Outstation Pune",
description: "Tempo Traveller for Outstation Pune is designed for groups traveling from Pune to nearby cities, hill stations, pilgrimage destinations, beaches, and longer holiday routes. The vehicle can be arranged for one-way or round-trip journeys according to the group's complete itinerary."
},
{
name: "Tempo Traveller for Family Trip Pune",
description: "Families can choose Tempo Traveller for Family Trip Pune when several relatives want to travel together in one dedicated vehicle. Spacious seating and coordinated transportation can make family holidays more convenient, particularly when children, adults, and senior members are traveling together."
},
{
name: "Tempo Traveller for Group Travel Pune",
description: "Tempo Traveller for Group Travel Pune is useful for friends, relatives, community groups, and organized tour parties. Traveling in one vehicle reduces the need to coordinate multiple cars and helps the entire group follow the same route and schedule."
},
{
name: "Tempo Traveller for Corporate Events Pune",
description: "Tempo Traveller for Corporate Events Pune provides organized transportation for employees, business teams, conferences, meetings, and company events. Dedicated group travel can help coordinate employee pickup, venue transfers, sightseeing, and return transportation according to the event schedule."
},
{
name: "Tempo Traveller for Wedding Pune",
description: "Tempo Traveller for Wedding Pune is suitable for transporting relatives, guests, and wedding groups between homes, hotels, venues, and other locations. Dedicated vehicles can simplify guest movement during ceremonies and provide convenient group transportation throughout the wedding schedule."
},
{
name: "Tempo Traveller for Airport Pickup Pune",
description: "Tempo Traveller for Airport Pickup Pune offers group transportation for families, business travelers, and tour parties arriving at or departing from the airport. A dedicated vehicle provides enough shared seating and luggage space when several passengers need to travel together."
},
{
name: "Tempo Traveller for Picnic Pune",
description: "Tempo Traveller for Picnic Pune is a convenient choice for families, friends, schools, and organizations planning a day outing. The vehicle can accommodate the group and their belongings while providing transportation between the Pune starting point, picnic destination, and return location."
},
{
name: "Tempo Traveller for School Trip Pune",
description: "Tempo Traveller for School Trip Pune can be considered for smaller educational groups, student outings, teacher travel, and organized school excursions. Group transportation helps simplify movement between the school, destination, sightseeing locations, and return point."
},
{
name: "Tempo Traveller for Local Sightseeing Pune",
description: "Tempo Traveller for Local Sightseeing Pune is suitable for groups exploring attractions within Pune and nearby areas. A dedicated vehicle allows travelers to move conveniently between several locations while keeping the group together throughout the sightseeing schedule."
},
{
name: "Affordable Tempo Traveller Pune",
description: "Affordable Tempo Traveller Pune provides a practical option for groups that want shared transportation without arranging several smaller vehicles. Choosing a vehicle according to the actual passenger count can help balance travel comfort, seating capacity, and overall trip expenses."
},
{
name: "Tempo Traveller Near Me Pune",
description: "Tempo Traveller Near Me Pune is useful for travelers searching for convenient group transportation around Pune for local or outstation journeys. Ruturaj Enterprises can assist with suitable vehicle selection based on the group size, destination, travel duration, and required facilities."
},
{
name: "Tempo Traveller Rental Service Pune",
description: "Tempo Traveller Rental Service Pune covers a variety of travel requirements including family trips, corporate events, weddings, airport transfers, picnics, and sightseeing. The rental arrangement can be planned around the group's preferred dates, route, passenger capacity, and trip duration."
},
{
name: "Tempo Traveller for One Day Trip Pune",
description: "Tempo Traveller for One Day Trip Pune is ideal for groups planning a short outing without an overnight stay. The itinerary can be organized around destinations near Pune with suitable pickup, sightseeing, meal breaks, and return transportation."
},
{
name: "Tempo Traveller for Tourist Tour Pune",
description: "Tempo Traveller for Tourist Tour Pune provides dedicated group transportation for sightseeing and holiday journeys. Families, friends, and organized groups can use the vehicle to explore multiple destinations while keeping travel arrangements coordinated throughout the tour."
},
{
name: "Tempo Traveller for Marriage Pune",
description: "Tempo Traveller for Marriage Pune is useful for transporting wedding guests, relatives, and family members between different venues and accommodation locations. Dedicated group vehicles can make guest movement easier to coordinate during ceremonies, receptions, and related functions."
},
{
name: "Tempo Traveller for Corporate Travel Pune",
description: "Tempo Traveller for Corporate Travel Pune provides convenient transportation for employees, business teams, meetings, training programs, conferences, and official trips. A dedicated vehicle allows the group to travel together according to the company's schedule and destination requirements."
}
],
tableData: [
["Tempo Traveller Rental Pune", "Tempo Traveller Hire Pune"],
["Tempo Traveller Booking Pune", "AC Tempo Traveller on Rent Pune"],
["Non AC Tempo Traveller Pune", "Luxury Tempo Traveller Pune"],
["Tempo Traveller for Outstation Pune", "Tempo Traveller for Family Trip Pune"],
["Tempo Traveller for Group Travel Pune", "Tempo Traveller for Corporate Events Pune"],
["Tempo Traveller for Wedding Pune", "Tempo Traveller for Airport Pickup Pune"],
["Tempo Traveller for Picnic Pune", "Tempo Traveller for School Trip Pune"],
["Tempo Traveller for Local Sightseeing Pune", "Affordable Tempo Traveller Pune"],
["Tempo Traveller Near Me Pune", "Tempo Traveller Rental Service Pune"],
["Tempo Traveller for One Day Trip Pune", "Tempo Traveller for Tourist Tour Pune"],
["Tempo Traveller for Marriage Pune", "Tempo Traveller for Corporate Travel Pune"]
],
whychoose: [
{
WhyChooseheading: "Flexible Group Transportation",
WhyChoosedescription: "Tempo Travellers provide a convenient middle-ground between multiple cars and larger buses, making them suitable for many group sizes. Ruturaj Enterprises can help travelers choose an appropriate vehicle according to passenger count and journey requirements."
},
{
WhyChooseheading: "Options for Local and Outstation Trips",
WhyChoosedescription: "The same type of group transportation can be useful for Pune sightseeing as well as longer journeys to hill stations, pilgrimage destinations, beaches, and other cities. Travel arrangements can be planned around the selected destination and duration."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "For longer routes and sightseeing schedules, a comfortable cabin can make a noticeable difference to the overall experience. AC Tempo Traveller options provide a convenient environment for passengers traveling together over extended distances."
},
{
WhyChooseheading: "Suitable for Families and Friends",
WhyChoosedescription: "Family vacations and friend-group outings are easier to coordinate when everyone has one dedicated vehicle. Passengers can travel together with shared luggage space while following the same route, stops, and planned schedule."
},
{
WhyChooseheading: "Convenient for Weddings and Events",
WhyChoosedescription: "Wedding guests and event participants often need transportation between several locations throughout the day. Dedicated Tempo Traveller services can help coordinate guest movement between pickup points, hotels, venues, and return destinations."
},
{
WhyChooseheading: "Useful for Corporate Requirements",
WhyChoosedescription: "Business teams can use dedicated Tempo Travellers for meetings, conferences, employee transportation, training programs, and corporate events. Group travel helps maintain a coordinated schedule while reducing the need for several separate vehicles."
},
{
WhyChooseheading: "Practical One-Day Travel",
WhyChoosedescription: "Short trips do not always require a large bus, making a Tempo Traveller a practical choice for one-day outings and nearby sightseeing. Groups can plan a convenient route with pickup, destination travel, sightseeing stops, and return arrangements."
},
{
WhyChooseheading: "Group Travel Made Simpler",
WhyChoosedescription: "Keeping passengers together can make the overall journey easier to manage from departure through return. Ruturaj Enterprises can coordinate the transportation requirement around the group's passenger strength, destination, travel dates, and preferred vehicle category."
}
]
};












const faqData = [
{
question: "What is a Tempo Traveller and when is it useful?",
answer: "A Tempo Traveller is a group travel vehicle designed to accommodate multiple passengers on local, outstation, sightseeing, pilgrimage, and tour journeys. Ruturaj Enterprises provides rental options for families, friends, corporate teams, wedding groups, and other parties looking for convenient shared transportation."
},
{
question: "What seating capacities are available in a Tempo Traveller on rent?",
answer: "Tempo Travellers are available in different seating configurations to suit varying group sizes. Ruturaj Enterprises can help you select an appropriate vehicle based on the number of passengers, luggage requirements, journey distance, and type of trip you are planning."
},
{
question: "Can I hire a Tempo Traveller for an outstation trip?",
answer: "Outstation rental is a popular use of Tempo Travellers for family holidays, weekend trips, pilgrimage tours, destination visits, and group excursions. A dedicated vehicle allows the complete group to travel together and follow a common itinerary without arranging multiple cars."
},
{
question: "Is a Tempo Traveller suitable for family trips?",
answer: "Families can choose a Tempo Traveller when several relatives need to travel together for a vacation, wedding, pilgrimage, or sightseeing tour. Having one vehicle simplifies coordination and provides a convenient way to manage passengers and luggage throughout the journey."
},
{
question: "Can corporate groups rent a Tempo Traveller?",
answer: "Corporate teams can hire a Tempo Traveller for employee outings, business travel, conferences, team-building activities, and company tours. A dedicated group vehicle helps employees travel together while keeping the transportation schedule aligned with the organization's itinerary."
},
{
question: "Can I book a Tempo Traveller for a wedding function?",
answer: "Wedding parties can arrange Tempo Traveller rentals to transport family members and guests between cities, hotels, venues, and other locations. The vehicle can be selected according to the number of passengers and the transportation schedule required for the wedding events."
},
{
question: "Can a Tempo Traveller be used for a pilgrimage tour?",
answer: "Pilgrimage groups can use a Tempo Traveller for temple visits and multi-destination religious tours. Traveling together makes it easier to coordinate departure times, sightseeing stops, meal breaks, and accommodation transfers while keeping the group organized throughout the journey."
},
{
question: "How do I choose the right Tempo Traveller for my group?",
answer: "The right vehicle depends on passenger count, luggage volume, trip duration, route, and the level of space your group prefers. Ruturaj Enterprises can help identify a suitable seating capacity so the vehicle matches the practical requirements of your planned journey."
},
{
question: "Can I rent a Tempo Traveller for a one-day trip?",
answer: "A Tempo Traveller can be a convenient option for one-day sightseeing trips, family outings, picnics, local excursions, and nearby destination visits. The travel plan can be organized around your preferred pickup time, destinations, sightseeing schedule, and return timing."
},
{
question: "Why choose Ruturaj Enterprises for Tempo Traveller rental?",
answer: "Ruturaj Enterprises offers Tempo Traveller rental solutions for different types of group journeys. From short local outings to extended outstation tours, vehicle selection can be planned according to passenger capacity, itinerary, luggage, and travel requirements for a more organized group transportation experience."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash Jagtap",
feedback:
"We rented a Tempo Traveller from Ruturaj Enterprises for a family outing and found it much easier than arranging several cars. Everyone traveled together, luggage was easier to manage, and coordinating our sightseeing schedule was simple. It was a practical choice for our group trip.",
rating: 5
},
{
id: 2,
name: "Miss. Radhika Joshi",
feedback:
"Our friends' group needed a vehicle for an outstation tour, and the Tempo Traveller worked well for our travel plans. Ruturaj Enterprises helped us with the group transportation arrangement, allowing everyone to stay together throughout the journey and making the overall trip more convenient.",
rating: 5
}
];































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent",
  "image": "https://ruturajenterprises.com/assets/images/tempo-traveller-on-rent.webp",
  "description":
    "Tempo Traveller On Rent for family trips, group tours, corporate travel, weddings, airport transfers, pilgrimages, and outstation journeys from Pune. Ruturaj Enterprises offers comfortable AC and non-AC Tempo Traveller options in different seating capacities, with experienced drivers, convenient pickup arrangements, flexible rental plans, and reliable transportation for local as well as long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/tempo-traveller-on-rent"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Tempo Traveller On Rent | Tempo Traveller Rental Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Tempo Traveller On Rent in Pune for family trips, group travel, corporate events, weddings, airport transfers and outstation journeys. Choose comfortable AC, non-AC and luxury Tempo Traveller options with flexible rental plans."
  />

  <meta
    name="keywords"
    content="Tempo Traveller Rental Pune, Tempo Traveller Hire Pune, Tempo Traveller Booking Pune, AC Tempo Traveller on Rent Pune, Non AC Tempo Traveller Pune, Luxury Tempo Traveller Pune, Tempo Traveller for Outstation Pune, Tempo Traveller for Family Trip Pune, Tempo Traveller for Group Travel Pune, Tempo Traveller for Corporate Events Pune, Tempo Traveller for Corporate Travel Pune, Tempo Traveller for Wedding Pune, Tempo Traveller for Marriage Pune, Tempo Traveller for Airport Pickup Pune, Tempo Traveller for Airport Drop Pune, Tempo Traveller for Local Sightseeing Pune, Tempo Traveller for Pune Darshan, Tempo Traveller for Picnic Pune, Tempo Traveller for School Trip Pune, Tempo Traveller for College Trip Pune, Tempo Traveller for Religious Tour Pune, Tempo Traveller for Pilgrimage Pune, Tempo Traveller for One Day Trip Pune, Tempo Traveller for Multi Day Trip Pune, Tempo Traveller on Rent Near Me Pune, Affordable Tempo Traveller Rental Pune, Comfortable Tempo Traveller Hire Pune, AC Tempo Traveller Rental Pune, Non AC Tempo Traveller Rental Pune, Luxury Tempo Traveller on Rent Pune, 13 Seater Tempo Traveller Pune, 17 Seater Tempo Traveller Pune, 20 Seater Tempo Traveller Pune, 26 Seater Tempo Traveller Pune, Tempo Traveller Rental for Family Pune, Tempo Traveller Rental for Group Pune, Tempo Traveller Hire for Outstation Pune, Tempo Traveller Booking for Tour Pune, Tempo Traveller for Maharashtra Tour Pune, Tempo Traveller for Goa Trip Pune, Tempo Traveller for Mumbai Trip Pune, Tempo Traveller for Shirdi Trip Pune, Tempo Traveller for Mahabaleshwar Trip Pune, Tempo Traveller for Nashik Trip Pune, Tempo Traveller for Konkan Trip Pune, Tempo Traveller Bus Rental Pune, Tempo Traveller Tour Package Pune, Tempo Traveller Travel Service Pune, Ruturaj Enterprises Tempo Traveller Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrent;